const normalizeCoordinateInput = (rawValue: string | number): string => {
  const value = String(rawValue);
  const sign = value.includes('-') ? '-' : '';
  const filtered = value.replace(/[^0-9.]/g, '');
  if (filtered === '') {
    return '0';
  }

  const firstDotIndex = filtered.indexOf('.');
  const withoutExtraDots =
    firstDotIndex === -1
      ? filtered
      : `${filtered.slice(0, firstDotIndex + 1)}${filtered.slice(firstDotIndex + 1).replace(/\./g, '')}`;
  if (withoutExtraDots === '.') {
    return `${sign}0.`;
  }

  let unsignedValue = withoutExtraDots;
  if (unsignedValue.startsWith('0') && unsignedValue.length > 1 && unsignedValue[1] !== '.') {
    const stripped = unsignedValue.replace(/^0+/, '') || '0';
    unsignedValue = stripped[0] === '.' ? `0${stripped}` : stripped;
  }

  return `${sign}${unsignedValue}`;
};

const parseCoordinateNumber = (rawValue: string | number): number => {
  const normalized = String(rawValue).replace(/,/g, '.');
  const parsed = parseFloat(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};

interface CoordinateValue {
  x: number | string;
  y: number | string;
}

const buildCoordinateInputs = ({ coordinates }: { coordinates: CoordinateValue[] }): { x: string; y: string }[] =>
  coordinates.map((coordinate) => {
    return { x: String(coordinate.x), y: String(coordinate.y) };
  });

export { normalizeCoordinateInput, parseCoordinateNumber, buildCoordinateInputs };
